module.exports = __webpack_public_path__ + "images/emoji/snake.c086ec35b33e1d8e9f6c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/snake.png
// module id = OTm5
// module chunks = 14